import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import Image from 'next/image';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

import PdfThumbImage from '../../PdfThumbImage';

const fadeIn = (from = 0) => keyframes`
  from {
    opacity: ${from};
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = (to = 0) => keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: ${to};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100vh;
  flex: 0 0 360px;
  border: 1px solid ${theme.colors.zinc_300};
  margin-top: auto;
  background-color: ${theme.colors.white};
  box-shadow: ${theme.elevation.md};
  opacity: 0;
  overflow-x: hidden;
  overflow-y: scroll;

  &.visible {
    z-index: ${VIEWER_Z_INDEX.pageListButton};
    animation: ${fadeIn()} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }

  &.hidden {
    z-index: ${VIEWER_Z_INDEX.root};
    display: none;
    animation: ${fadeOut()} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }
`;

export const FlexCloseButton = styled(Flex)`
  position: fixed;
  width: 358px;
  padding: 16px 32px;
  background-color: ${theme.colors.white};
  border-radius: 0 8px 0 0;

  &.visible {
    z-index: ${VIEWER_Z_INDEX.pageListButton};
  }

  &.hidden {
    z-index: ${VIEWER_Z_INDEX.root};
  }
`;

export const StackPageWrapper = styled(Flex)`
  padding: 69px 0 32px;
`;

export const Page = styled.div`
  display: flex;
  width: 240px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  opacity: 0.5;

  transition: opacity 0.15s ease-in-out;

  &.current-page {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

export const PageInnerWrapper = styled.div`
  position: relative;
  width: 360px;
  padding: 16px 32px;
  background: ${theme.colors.white};
  border-radius: 4px;
  cursor: pointer;

  &.current-page {
    background: ${theme.colors.skyblue_50};
  }

  & > span {
    position: unset !important;
    img {
      position: relative !important;
      height: auto !important;
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.pageListButton};
  top: 32px;
  left: 48px;

  opacity: 1;

  transition: opacity 0.15s ease-in-out;
  &.disable {
    opacity: 0.25;
  }
`;

export const ButtonOpenDrawer = styled(Button)`
  position: relative;
  height: 59px;
  border-radius: 9999px;

  &.visible {
    z-index: ${VIEWER_Z_INDEX.pageListButton};
    animation: ${fadeIn(0.25)} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }

  &.hidden {
    z-index: ${VIEWER_Z_INDEX.root};
    animation: ${fadeOut(0.25)} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }
`;

export const BlindImage = styled(Image)`
  border: 1px solid ${theme.colors.zinc_300} !important;
  border-radius: 8px;
  -webkit-user-drag: none;

  user-select: none;

  &.is-blind {
    filter: blur(8px);
  }
`;

export const BlindPictureImage = styled(PdfThumbImage)`
  border: 1px solid ${theme.colors.zinc_300} !important;
  border-radius: 8px;

  &.is-blind {
    filter: blur(8px);
  }
`;
